import BottomNav from './BottomNav';
import Phone from './Phone';
import { C } from './theme';

const animations = `
@keyframes aiOrbit1 {
  0% { transform: rotate(0deg) translateX(52px) rotate(0deg); }
  100% { transform: rotate(360deg) translateX(52px) rotate(-360deg); }
}
@keyframes aiOrbit2 {
  0% { transform: rotate(120deg) translateX(44px) rotate(-120deg); }
  100% { transform: rotate(480deg) translateX(44px) rotate(-480deg); }
}
@keyframes aiOrbit3 {
  0% { transform: rotate(240deg) translateX(60px) rotate(-240deg); }
  100% { transform: rotate(600deg) translateX(60px) rotate(-600deg); }
}
@keyframes aiGlow {
  0%, 100% { box-shadow: 0 0 20px rgba(210,58,59,0.15), 0 0 60px rgba(210,58,59,0.05); }
  50% { box-shadow: 0 0 30px rgba(210,58,59,0.25), 0 0 80px rgba(210,58,59,0.1); }
}
@keyframes aiRingPulse {
  0% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.15); opacity: 0; }
  100% { transform: scale(1); opacity: 0.3; }
}
@keyframes aiFadeUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes aiTypewriter {
  from { width: 0; }
  to { width: 100%; }
}
@keyframes aiBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
@keyframes aiCardSlide {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}
`;

const AIScreen = () => {
    return (
        <Phone>
            <style>{animations}</style>
            <div style={{
                flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
                justifyContent: "center", padding: "32px 24px", textAlign: "center",
                background: "radial-gradient(ellipse at 50% 30%, rgba(210,58,59,0.04) 0%, #F5F6FA 60%, #fff 100%)",
                overflow: "hidden", position: "relative",
            }}>
                {/* Orbiting particles around brain icon */}
                <div style={{ position: "relative", width: 140, height: 140, marginBottom: 32 }}>
                    {/* Pulsing ring */}
                    <div style={{
                        position: "absolute", inset: -8,
                        borderRadius: "50%", border: `2px solid ${C.accent}20`,
                        animation: "aiRingPulse 3s ease-in-out infinite",
                    }} />
                    <div style={{
                        position: "absolute", inset: -20,
                        borderRadius: "50%", border: `1px solid ${C.accent}10`,
                        animation: "aiRingPulse 3s ease-in-out 0.5s infinite",
                    }} />

                    {/* Central brain icon */}
                    <div style={{
                        position: "absolute", top: "50%", left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 72, height: 72, borderRadius: 20,
                        background: `linear-gradient(145deg, ${C.accent}, #B22830)`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        animation: "aiGlow 3s ease-in-out infinite",
                    }}>
                        <span className="material-symbols-rounded" style={{ fontSize: 36, color: "#fff" }}>
                            neurology
                        </span>
                    </div>

                    {/* Orbiting particles */}
                    <div style={{
                        position: "absolute", top: "50%", left: "50%",
                        width: 0, height: 0,
                        animation: "aiOrbit1 8s linear infinite",
                    }}>
                        <div style={{
                            width: 10, height: 10, borderRadius: "50%",
                            background: `linear-gradient(135deg, ${C.accent}, #E86B6B)`,
                            boxShadow: `0 0 8px ${C.accent}40`,
                            marginLeft: -5, marginTop: -5,
                        }} />
                    </div>
                    <div style={{
                        position: "absolute", top: "50%", left: "50%",
                        width: 0, height: 0,
                        animation: "aiOrbit2 6s linear infinite",
                    }}>
                        <div style={{
                            width: 7, height: 7, borderRadius: "50%",
                            background: "#7C3AED",
                            boxShadow: "0 0 8px rgba(124,58,237,0.4)",
                            marginLeft: -3.5, marginTop: -3.5,
                        }} />
                    </div>
                    <div style={{
                        position: "absolute", top: "50%", left: "50%",
                        width: 0, height: 0,
                        animation: "aiOrbit3 10s linear infinite",
                    }}>
                        <div style={{
                            width: 6, height: 6, borderRadius: "50%",
                            background: "#3B82F6",
                            boxShadow: "0 0 6px rgba(59,130,246,0.4)",
                            marginLeft: -3, marginTop: -3,
                        }} />
                    </div>
                </div>

                {/* Title with gradient */}
                <div style={{
                    fontSize: 26, fontWeight: 800, marginBottom: 6,
                    background: `linear-gradient(135deg, ${C.accent}, #7C3AED)`,
                    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                    fontFamily: "'DM Sans', sans-serif",
                    animation: "aiFadeUp 0.5s ease-out",
                }}>
                    Maghil AI
                </div>

                <div style={{
                    fontSize: 13, color: C.t3, marginBottom: 24,
                    animation: "aiFadeUp 0.5s ease-out 0.1s both",
                }}>
                    Intelligence layer for your business
                </div>

                {/* Coming Soon — typewriter style */}
                <div style={{
                    display: "inline-flex", alignItems: "center", gap: 8,
                    padding: "10px 22px", borderRadius: 50,
                    background: "rgba(210,58,59,0.06)",
                    border: `1px dashed ${C.accent}30`,
                    marginBottom: 36,
                    animation: "aiFadeUp 0.5s ease-out 0.2s both",
                }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: C.accent, letterSpacing: 1.5, textTransform: "uppercase" }}>
                        Coming Soon
                    </span>
                    <span style={{
                        display: "inline-block", width: 2, height: 16,
                        background: C.accent, borderRadius: 1,
                        animation: "aiBlink 1s step-end infinite",
                    }} />
                </div>

                {/* Feature cards with staggered animation */}
                <div style={{ width: "100%", maxWidth: 300 }}>
                    {[
                        { icon: "query_stats", label: "Ask anything", desc: "Natural language queries about your data", color: C.accent },
                        { icon: "auto_graph", label: "Smart forecasts", desc: "Revenue & demand predictions", color: "#7C3AED" },
                        { icon: "lightbulb", label: "Action insights", desc: "AI-powered recommendations", color: "#3B82F6" },
                        { icon: "notifications_active", label: "Smart alerts", desc: "Anomaly detection & notifications", color: "#16A34A" },
                    ].map((f, i) => (
                        <div key={i} style={{
                            display: "flex", alignItems: "center", gap: 14,
                            padding: "14px 16px", marginBottom: 10,
                            background: "#fff", borderRadius: 14,
                            border: `1px solid ${C.cardBorder}`,
                            boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                            animation: `aiCardSlide 0.4s ease-out ${0.3 + i * 0.1}s both`,
                        }}>
                            <div style={{
                                width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                                background: `${f.color}10`,
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                <span className="material-symbols-rounded" style={{ fontSize: 18, color: f.color }}>{f.icon}</span>
                            </div>
                            <div style={{ textAlign: "left" }}>
                                <div style={{ fontSize: 13, fontWeight: 600, color: C.t1 }}>{f.label}</div>
                                <div style={{ fontSize: 11, color: C.t3, marginTop: 1 }}>{f.desc}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <BottomNav />
        </Phone>
    );
};

export default AIScreen;
